import React, {useState, useEffect} from 'react';
import {Box, Stack, Grid} from '@mui/material';
import ArrTreeView from '../../../../../common/arr-tree-view/ArrTreeView';
import {useFieldData} from '../../../../../../hooks/session-search/useSessionSearch';
import {FieldTypeProps} from '../FieldTypeProps';
import './SavedSearchResultsField.scss';
import '../FieldTypes.scss';
import {disableEmptyParents, findItemById} from '../../field-types/fieldTypesUtils';

export interface SavedSearchesFieldTypeProps
  extends Omit<FieldTypeProps, 'onCriteriaChaged'> {
  onCriteriaChaged?: (value: string[]) => void;
}

const SavedSearchResultsFieldType: React.FC<SavedSearchesFieldTypeProps> = ({
  type = 'SAVEDSEARCHES',
  onCriteriaChaged,
  onValidated,
}) => {
  const {data} = useFieldData(type);
  const [_, setSelectedSavedSearch] = useState<string[]>([]);
  const [treeItems, setTreeItems] = useState<any[]>([]);

  const convertToTree = (items: any[]) => {
    const map: any = {};
    const roots: any[] = [];
    items.forEach((item) => {
      map[item.id] = {
        id: item.id,
        label: item.text,
        isGroup: item.isGroup,
        parent: item.parent,
        fileType: item.isGroup ? 'folder' : 'tag',
        children: [],
      };
    });
    // build the tree
    items.forEach((item) => {
      if (item.parent && item.parent !== '#') {
        map[item.parent]?.children.push(map[item.id]);
      } else {
        roots.push(map[item.id]);
      }
    });

    return disableEmptyParents(roots);
  };
  // Handle tree selection
  useEffect(() => {
    if (!data?.workProductItemsDetails) return;
    const tree = convertToTree(data.workProductItemsDetails);
    setTreeItems(tree);
  }, [data]);

  const validateForm = (selected: string[]) => {
    const valid = selected.length > 0;
    onValidated?.(valid);
  };

  const handleTreeChange = (selectedItems: string[] | null) => {
    if (!selectedItems) return;
    setSelectedSavedSearch(selectedItems);
    validateForm(selectedItems);
    const selectedData = selectedItems
      .map((id) => findItemById(treeItems, id))
      .filter((item) => item && !item.isGroup && item.parent !== '#')
      .map((item) => item!.id);
    onCriteriaChaged?.(selectedData);
  };

  return (
    <Grid
      container
      className={`savedSearch-panel ${treeItems?.length ? 'has-data' : 'no-data'}`}
    >
      <Grid size={12}>
        <Stack spacing={2}>
          <Box>
            <ArrTreeView
              itemsList={treeItems}
              isChildrenIndendation={true}
              handleNoResultMessage="No Saved Search Result Found"
              allowGlobalSelect
              multipleSelection
              isShowCheckbox={true}
              setSelectedItem={handleTreeChange}
              isShowFileType={false}
            />
          </Box>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default SavedSearchResultsFieldType;